import React__default from 'react';
import Info from '../../Info/Info.esm.js';
import styles from './ExomeAddOnContainer.module.esm.js';

var ExomeAddOnTooltip = function () { return (React__default.createElement(Info, { className: styles.tooltip, content: React__default.createElement("div", null, "Secondary findings will be delivered as separate reports at no additional charge."), tooltipClassName: styles.rereqTooltipCard })); };

export { ExomeAddOnTooltip as default };
//# sourceMappingURL=ExomeAddOnTooltip.esm.js.map
